(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentReportController', ShipmentReportController);

    ShipmentReportController.$inject = ['$scope','ShipmentReport','ShipmentCustomService','XLSXExportService','ToastrService','MiscService','DateUtils'];

    function ShipmentReportController($scope, ShipmentReport, ShipmentCustomService, XLSXExportService, ToastrService, MiscService, DateUtils) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.downloadReport = downloadReport;
        vm.openCalendar = openCalendar;
        vm.refresh = refresh;
        vm.onStartDateChange = onStartDateChange;
        vm.lastDayOfMonth = lastDayOfMonth;
        vm.resetForm = resetForm;
        vm.getSeller = getSeller;
        vm.buildPurchaseString = buildPurchaseString;
        vm.modDateToggle = modDateToggle;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        vm.dateRange = "Shipment Date";

        resetForm();
        initFilterData();

        vm.modDateOptions = ['Yes','No'];
        function modDateToggle(option) {
            vm.filterModel.modDate = option;
            if(option === 'Yes') {
                vm.dateRange = "Modified Date";
            } else {
                vm.dateRange = "Shipment Date";
            }
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadAll() {
            vm.shipmentsList = [];
            vm.statusText = "Fetching Shipments";
            var queryParams = {
                page: 0,
                size: 32767
            };
            queryParams = Object.assign({},queryParams, vm.filterModel);
            ShipmentReport.query(queryParams, function( result ) {
                console.log(JSON.stringify(result));
                vm.shipmentsList = result;
                generateStatusText();
            }, function( error ) {
                ToastrService.error("Something went terribly wrong");
            })
        }

        function downloadReport() {
            if(vm.shipmentsList.length > 0) {
                XLSXExportService.downloadShipmentReport(vm.shipmentsList).then(function(result) {
                    var file = new Blob([result.data], {type: 'application/vnd.ms-excel'});
                    saveAs(file, "ShipmentReport.xls");
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Failed to download Shipment Report", "Error");
                    }
                });
            } else {
                ToastrService.info("Nothing to download", "Info");
            }
        }

        function refresh() {
            loadAll();
        }

        function initFilter() {
            vm.filterModel = {
                shipmentNum: '',
                shipmentDateFrom: MiscService.generateStartDate(new Date()),
                shipmentDateTo: MiscService.generateStartDate(new Date()),
                status: '',
                qtyBalesFrom: null,
                qtyBalesTo: null,
                lcNum: '',
                lcBankRef: '',
                blNum: '',
                boeRef: '',
                bookingNum: '',
                purchaseCropYear: '',
                saleCropYear: '',
                purchaseContractId: 0,
                saleContractId: 0,
                purchaseInvoiceId: 0,
                saleInvoiceId: 0,
                purchaseGrowthId: 0,
                saleGrowthId: 0,
                buyerId: 0,
                sellerId: 0,
                forReport: true,
                statusDraft: true,
                statusAllocated: true,
                statusScheduled: true,
                statusDraftReceived: true,
                statusShipped: true,
                statusInvoiced: true,
                statusCancelled: false,
                modDate: 'No'
            }
        }

        function initFilterData() {
            ShipmentCustomService.returnUsedContracts("PURCHASE").then(function (data) {
                vm.purchaseContracts = data.data;
                vm.purchaseContracts.unshift({id: 0, contractNum: 'Choose a purchase contract'});
            }, function (error) {
                vm.purchaseContracts = [];
            });
            ShipmentCustomService.returnUsedContracts("SALE").then(function (data) {
                vm.saleContracts = data.data;
                vm.saleContracts.unshift({id: 0, contractNum: 'Choose a sale contract'});
            }, function (error) {
                vm.saleContracts = [];
            });
            ShipmentCustomService.returnUsedInvoices("PURCHASE").then(function (data) {
                vm.purchaseInvoices = data.data;
                vm.purchaseInvoices.unshift({id: 0, invNum: 'Choose a purchase invoice'});
            }, function (error) {
                vm.purchaseInvoices = [];
            });
            ShipmentCustomService.returnUsedInvoices("SALE").then(function (data) {
                vm.saleInvoices = data.data;
                vm.saleInvoices.unshift({id: 0, invNum: 'Choose a sale invoice'});
            }, function (error) {
                vm.saleInvoices = [];
            });
            ShipmentCustomService.returnUsedGrowths().then(function( data ) {
                vm.growths = data.data;
                vm.growths.unshift({id:0, location: 'Choose a growth'});
            }, function(error) {
                vm.growths = [];
            });
            ShipmentCustomService.returnUsedCompanies("BUYER").then( function( data ) {
                vm.buyers = data.data;
                vm.buyers.unshift({id:0, name: 'Choose a buyer'});
            }, function( error ) {
                vm.buyers = [];
            });
            ShipmentCustomService.returnUsedCompanies("SELLER").then( function( data ) {
                vm.sellers = data.data;
                vm.sellers.unshift({id:0, name: 'Choose a seller'});
            }, function( error ) {
                vm.sellers = [];
            });
        }

        function resetForm() {
            vm.shipmentsList = [];
            vm.statusText = "Waiting for Command...";
            initFilter();
            modDateToggle('No');
        }

        function onStartDateChange() {
            vm.filterModel.shipmentDateTo = MiscService.onStartDateChange(vm.filterModel.shipmentDateFrom, vm.filterModel.shipmentDateTo);
        }

        function lastDayOfMonth() {
            vm.filterModel.shipmentDateTo = MiscService.generateLastDayOfMonth(vm.filterModel.shipmentDateTo);
        }

        function generateStatusText() {
            if(vm.filterModel.shipmentDateFrom.getTime() === vm.filterModel.shipmentDateTo.getTime()) {
                vm.statusText = "Showing " + vm.shipmentsList.length + " Shipments for " + vm.filterModel.shipmentDateFrom.toLocaleDateString('en-US');
            } else {
                vm.statusText = "Showing " + vm.shipmentsList.length + " Shipments from " + vm.filterModel.shipmentDateFrom.toLocaleDateString('en-US') + " to " + vm.filterModel.shipmentDateTo.toLocaleDateString('en-US');
            }
        }

        function getSeller(s) {
            var returnMe = "";
            if( s.contract !== undefined && s.contract !== null ) {
                if( s.contract.seller !== undefined && s.contract.seller !== null ) {
                    if( s.contract.seller.name !== undefined && s.contract.seller.name !== null ) {
                        returnMe = s.contract.seller.name;
                    }
                }
            }
            return returnMe;
        }

        function buildPurchaseString(s) {
            var returnMe = "";
            var count = 0;
            if( s.contract !== undefined && s.contract !== null ) {
                returnMe += s.contract.contractNum;
                count++;
            }
            if( s.contractB !== undefined && s.contractB !== null) {
                if(count > 0) {
                    returnMe += ", ";
                }
                returnMe += s.contractB.contractNum;
                count++;
            }
            if(s.contractC !== undefined && s.contractC !== null) {
                if(count > 0) {
                    returnMe += ", ";
                }
                returnMe += s.contractC.contractNum;
                count++;
            }
            if(s.contractD !== undefined && s.contractD !== null) {
                if(count > 0) {
                    returnMe += ", ";
                }
                returnMe += s.contractD.contractNum;
                count++;
            }
            if(s.contractE !== undefined && s.contractE !== null) {
                if(count > 0) {
                    returnMe += ", ";
                }
                returnMe = s.contractE.contractNum;
            }
            return returnMe;
        }
    }
})();
